import * as React from 'react';
import { useGetTimberStorageQuery } from "../../../apis/TimberStorage.api";
import { PrimaryTimberStorage, TimberStorage } from "../../../types/models/TimberStorage";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: TimberStorage;
};

export const TimberStorageNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const TimberStorageName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetTimberStorageQuery(PrimaryTimberStorage.fromId(id))
    return (<TimberStorageNameDisplay data={data}/>)
}

export default TimberStorageName;
